/**
 * La largeur d'une figure de l'énoncé, en règle pure : la feuille de `<RichText>` l'écrit en CSS
 * (`richTextStyles`, `img { max-width }`), cette fonction la dit en nombres pour ceux qui mettent un
 * énoncé en page (`pages/StudentLivePage/liveColumns`) et pour les tests.
 *
 *  - **Dans un bloc étroit** (moins de `FIGURE_CAP_FROM`) : toute la largeur du bloc — un téléphone, le
 *    volet de l'activité au live.
 *  - **Dans un bloc large** : la moitié du bloc (`FIGURE_SHARE`), pour qu'une figure pleine largeur ne
 *    devienne pas si haute qu'elle pousse la consigne sous le pli…
 *  - … **mais jamais moins que `FIGURE_FLOOR`** (Wajih, daily du 23/10) : sans plancher, l'activité agrandie
 *    au live (son volet de 420 à 680 px) faisait RÉTRÉCIR la figure, de 388 à 324 px, parce qu'elle passait
 *    le seuil des 600 px. Le plancher est un peu plus large que le volet étroit : agrandir ne la réduit
 *    jamais. Ailleurs, il ne change qu'un bloc de 600 à 800 px (une feuille ou une carte de l'espace
 *    parent), où la figure prend 400 px au lieu de 300 à 400.
 * La largeur se lit sur le BLOC, jamais sur la fenêtre.
 */

/** À partir de ce bloc, la figure se plafonne. */
export const FIGURE_CAP_FROM = 600
/** La part d'un bloc large qu'une figure prend au plus. */
export const FIGURE_SHARE = 0.5
/** Le plus étroit qu'une figure plafonnée se fasse : un peu plus que le volet de l'activité au live (388 px). */
export const FIGURE_FLOOR = 400

/** La largeur au plus d'une figure, dans un bloc de `block` px. */
export function figureMaxWidth(block: number): number {
    if (block < FIGURE_CAP_FROM) return block
    return Math.max(Math.min(block, FIGURE_FLOOR), block * FIGURE_SHARE)
}
